import callAPI from 'config/api';

const ROOT_API = process.env.NEXT_PUBLIC_API;
const API_VERSION = 'api/v1';

export async function getLocation() {
  const url = `${ROOT_API}/hub/${API_VERSION}/locations/`;

  return callAPI({
    url,
    method: 'GET',
    token: true,
    serverToken: true,
  });
}

export async function getLocationDefault() {
  const url = `${ROOT_API}/hub/${API_VERSION}/locations-default`;

  return callAPI({
    url,
    method: 'GET',
    token: true,
    serverToken: true,
  });
}

export async function getCurrentUser() {
  const url = `${ROOT_API}/auth/${API_VERSION}/auth/current-user`;

  return callAPI({
    url,
    method: 'GET',
    token: true,
    serverToken: true,
  });
}

export async function setLocationDefault(data) {
  const url = `${ROOT_API}/hub/${API_VERSION}/locations-default`;

  return callAPI({
    url,
    method: 'POST',
    token: true,
    serverToken: true,
    data,
  });
}

export async function getDetailLocation(id) {
  const url = `${ROOT_API}/hub/${API_VERSION}/locations/${id}`;

  return callAPI({
    url,
    method: 'GET',
    token: true,
    serverToken: true,
  });
}

export async function createLocation(id) {
  const url = `${ROOT_API}/hub/${API_VERSION}/locations/${id}`;

  return callAPI({
    url,
    method: 'POST',
    token: true,
    serverToken: true,
  });
}

export async function updateLocation(id, data) {
  const url = `${ROOT_API}/hub/${API_VERSION}/locations/${id}`;

  return callAPI({
    url,
    method: 'PUT',
    token: true,
    serverToken: true,
    data,
  });
}

export async function saveLocation(data) {
  const url = `${ROOT_API}/hub/${API_VERSION}/locations`;

  return callAPI({
    url,
    method: 'POST',
    token: true,
    serverToken: true,
    data,
  });
}
export async function deleteLocation(id) {
  const url = `${ROOT_API}/hub/${API_VERSION}/locations/${id}`;

  return callAPI({
    url,
    method: 'DELETE',
    token: true,
    serverToken: true,
  });
}
